/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_GROUP_COURSES } from "./actionTypes"
import { apiError, listGroupCoursesSuccess } from "./actions"

//Include Both Helper File with needed methods
import {
  getGroupCoursesNewApi,
  getCoursegroupsNewApi,
} from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(
      request.payload.idCourse === 0
        ? getGroupCoursesNewApi
        : getCoursegroupsNewApi,
      request.payload
    )
    if (response == undefined) throw new Error("API error")
    yield put(listGroupCoursesSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* groupCoursesListSaga() {
  yield takeEvery(LIST_GROUP_COURSES, list)
}

export default groupCoursesListSaga
